import React from 'react';
import { List } from 'immutable';
import moment from 'moment';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import { getFilteredCalendarEvents } from 'flow/utils/calendar-utils';
import { TypedMap } from 'flow/types/TypedMap';
import { Calendar, Event } from 'flow/types/Calendar';

interface Props {
    calendar: TypedMap<Calendar>;
}

const ContactScheduleEvents = ({ calendar }: Props) => {
    const { i18next } = useAppContext();

    const calendarEventsList = calendar.get('events');
    const startInterval = moment().startOf('day');
    const endInterval = moment().endOf('day');
    const events: List<TypedMap<Event>> =
        calendarEventsList &&
        getFilteredCalendarEvents(
            calendarEventsList,
            startInterval,
            endInterval,
        );
    const currentTime = moment();
    const futureEvents = events?.filter(
        (calendarEvent) => moment(calendarEvent.get('end')) > currentTime,
    );

    const renderCalendarEvents = (event: TypedMap<Event>) => {
        const eventStartTime = moment(event.get('start'));
        const eventEndTime = moment(event.get('end'));
        const eventKey = event.get('key');
        const eventDescription = event.getIn(['profile', 'description']);

        return (
            <div
                className="mx-4 flex items-center justify-between overflow-hidden"
                key={eventKey}
            >
                <div className="flex items-center whitespace-nowrap">
                    <Icon
                        className="me-2 size-6 text-gray-900"
                        iconKey="calendar"
                    />
                    <div className="leading-5 text-gray-800">
                        {eventDescription}
                    </div>
                </div>
                <div className="text-end text-xs text-gray-500">
                    {eventStartTime.format('HH:mm') +
                        ' - ' +
                        eventEndTime.format('HH:mm')}
                </div>
            </div>
        );
    };

    return (
        <main id="CalendarEvents" className="flex flex-col gap-3 p-2 pb-6">
            {futureEvents?.size > 0 ? (
                futureEvents.map(renderCalendarEvents)
            ) : (
                <div className="pb-2 text-center">
                    {i18next.t('contact.noCalendarEvents')}
                </div>
            )}
        </main>
    );
};

export default ContactScheduleEvents;
